import React from "react";
import { isRuleConditionAmountRounding } from "@common/helpers/rules";
import {
    ROUNDING_LEVEL_LABELS,
    TransactionRuleCondition,
} from "@common/types/transactionRule";
import { Tag } from "@design-system/Tag/Tag";
import { RuleTagRow } from "../RuleTagRow";
import { RULE_TAG_PROPS } from "../ruleTagUtils";

interface Props {
    condition: TransactionRuleCondition;
    isNegated?: boolean;
}

export const RuleAmountRoundingCondition: React.FC<Props> = ({
    condition,
    isNegated,
}) => {
    if (!isRuleConditionAmountRounding(condition.value)) {
        return null;
    }

    const { level, isCredit } = condition.value;
    const levelLabel = ROUNDING_LEVEL_LABELS[level];
    const direction = isCredit ? "Cash in" : "Cash out";
    const roundingLabel = isNegated ? "is not round" : "is round";

    return (
        <RuleTagRow label="Amount" type="condition">
            <Tag {...RULE_TAG_PROPS}>
                {direction} {roundingLabel}
                {!isNegated && ` ${levelLabel}`}
            </Tag>
        </RuleTagRow>
    );
};
